function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import { COLORS, Image, ImageEntity, Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
import NoRowsOverlay from 'app/components/team/playerstats/NoRowsOverlay';
import { useHistory } from 'react-router';
import { FPHTMLLink, FPLink } from 'app/components/links/link';
const PlayerWrapper = styled(FPHTMLLink).withConfig({
  componentId: "sc-1lat1sf-0"
})(["display:flex;align-items:center;height:inherit;text-decoration:none;overflow:hidden;"]);
const PlayerLink = styled(FPLink).withConfig({
  componentId: "sc-1lat1sf-1"
})(["display:flex;align-items:center;height:inherit;text-decoration:none;overflow:hidden;"]);
const ImageWrapper = styled.div.withConfig({
  componentId: "sc-1lat1sf-2"
})(["margin-right:8px;"]);
const StyledTypography = styled(Typography).withConfig({
  componentId: "sc-1lat1sf-3"
})(["&&&{overflow:hidden;text-overflow:ellipsis;white-space:normal;}"]);

// augment the props for the toolbar slot

const renderPlayer = props => {
  const {
    row
  } = props;
  const playerContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Player,
    height: 32,
    width: 32,
    src: row.image,
    circle: true,
    ratio: "1:1"
  })), /*#__PURE__*/React.createElement(StyledTypography, {
    variant: "body1"
  }, "".concat(row.firstName || '', " ").concat(row.lastName || '')));
  if (row.slug) {
    return /*#__PURE__*/React.createElement(PlayerLink, {
      to: "/player/".concat(row.slug),
      onClick: e => e.stopPropagation()
    }, playerContent);
  }
  return /*#__PURE__*/React.createElement(PlayerWrapper, {
    "data-sentry-element": "PlayerWrapper",
    "data-sentry-component": "renderPlayer",
    "data-sentry-source-file": "PlayerStatsGrid.tsx"
  }, playerContent);
};
const statGridData = {
  align: 'center',
  type: 'number'
};
const defaultColumns = [{
  field: 'rank',
  headerName: 'Pl.',
  valueGetter: params => {
    if (params.value) {
      return "".concat(params.value, ".");
    }
    const sortedRows = params.api.getSortedRows();
    const index = sortedRows.findIndex(row => row.slug === params.row.slug);
    return "".concat(index + 1, ".");
  },
  sortable: false,
  minWidth: 42,
  width: 42
}, {
  field: 'player',
  headerName: 'Spieler',
  renderCell: renderPlayer,
  sortable: false,
  width: 136
}, {
  field: 'matches',
  headerName: 'Spiele',
  ...statGridData,
  width: 86
}, {
  field: 'goals',
  headerName: 'Tore',
  ...statGridData,
  width: 74
}, {
  field: 'assists',
  headerName: 'Assists',
  ...statGridData,
  width: 89
}, {
  field: 'penalties',
  headerName: '11m',
  valueGetter: _ref => {
    let {
      row
    } = _ref;
    return "".concat(row.penaltiesHit, "/").concat(row.penaltiesTotal);
  },
  sortComparator: (_v1, _v2, param1, param2) => {
    const row1 = param1.api.getRow(param1.id);
    const row2 = param2.api.getRow(param2.id);
    return row1.penaltiesHit - row2.penaltiesHit;
  },
  ...statGridData,
  description: 'Elfmeter verwandelt/Elfmeter gesamt',
  width: 76
}, {
  field: 'yellowCards',
  headerName: 'Gelb',
  ...statGridData,
  width: 76
}, {
  field: 'yellowRedCards',
  headerName: 'Gelb-Rot',
  ...statGridData,
  width: 81
}, {
  field: 'redCards',
  headerName: 'Rot',
  ...statGridData,
  width: 70
}, {
  field: 'substitutesIn',
  headerName: 'Ein.',
  ...statGridData,
  description: 'Einwechslungen',
  width: 70
}, {
  field: 'substitutesOut',
  headerName: 'Aus.',
  ...statGridData,
  description: 'Auswechslungen',
  width: 73
}, {
  field: 'minutesPlayed',
  headerName: 'Min.',
  ...statGridData,
  description: 'gespielte Minuten',
  width: 74
}];
const topElevenColumn = {
  field: 'topEleven',
  headerName: 'Elf d. Woche',
  ...statGridData,
  description: 'Anzahl der Nominierungen in die Elf der Woche',
  width: 88
};
export default function PlayerStatsGrid(_ref2) {
  let {
    type,
    players,
    isLoading,
    error,
    calcMaxHeight,
    withTopEleven,
    ...props
  } = _ref2;
  const history = useHistory();
  const [maxHeight, setMaxHeight] = useState('100%');
  const apiRef = useGridApiRef();
  useEffect(() => {
    const maxHeight = calcMaxHeight();
    setMaxHeight(maxHeight);
  }, [isLoading, players, error]);
  useEffect(() => {
    const handleResize = () => {
      var _apiRef$current;
      const maxHeight = calcMaxHeight();
      setMaxHeight(maxHeight);
      if (typeof ((_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 ? void 0 : _apiRef$current.forceUpdate) === 'function') {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.forceUpdate();
      }
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [isLoading, players, error]);
  const handleRowClick = params => {
    const slug = params.row.slug;
    if (slug) {
      history.push("/player/".concat(slug));
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      height: maxHeight,
      width: '100%'
    },
    "data-sentry-element": "Box",
    "data-sentry-component": "PlayerStatsGrid",
    "data-sentry-source-file": "PlayerStatsGrid.tsx"
  }, /*#__PURE__*/React.createElement(DataGridPro, _extends({
    key: type,
    columns: [...defaultColumns, ...(withTopEleven ? [topElevenColumn] : [])],
    rows: players,
    initialState: {
      pinnedColumns: {
        left: ['rank', 'player']
      },
      sorting: {
        sortModel: [{
          field: 'matches',
          sort: 'desc'
        }]
      }
    },
    sortingOrder: ['desc', 'asc', null],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnReorder: true,
    disableVirtualization: true,
    disableColumnResize: true,
    loading: isLoading,
    slots: {
      noRowsOverlay: NoRowsOverlay
    },
    slotProps: {
      noRowsOverlay: {
        error
      }
    },
    onRowClick: handleRowClick,
    sx: {
      '&.MuiDataGrid-root': {
        border: 'none'
      },
      '&.MuiDataGrid-root .MuiDataGrid-iconButtonContainer': {
        width: '28px'
      },
      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
        py: '6px',
        outline: 'none',
        cursor: 'pointer'
      },
      '&.MuiDataGrid-root .MuiDataGrid-cell[data-field="player"], &.MuiDataGrid-root .MuiDataGrid-cell[data-field="rank"], &.MuiDataGrid-root .MuiDataGrid-columnHeader[data-field="player"], &.MuiDataGrid-root .MuiDataGrid-columnHeader[data-field="rank"]': {
        px: '8px'
      },
      '&.MuiDataGrid-root .MuiDataGrid-columnHeader': {
        outline: 'none'
      },
      '&.MuiDataGrid-root .MuiDataGrid-row:hover, &.MuiDataGrid-root .MuiDataGrid-row.Mui-hovered': {
        backgroundColor: COLORS.lightestGrey
      },
      '&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer': {
        flexDirection: 'row'
      },
      '&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitle': {
        whiteSpace: 'normal',
        lineHeight: 'normal',
        overflow: 'visible'
      },
      '&.MuiDataGrid-root .MuiDataGrid-columnSeparator': {
        display: 'none'
      }
    }
  }, props, {
    "data-sentry-element": "DataGridPro",
    "data-sentry-source-file": "PlayerStatsGrid.tsx"
  })));
}